<template>
  <div id="nav_fixed" v-if="tour">
    <b-navbar class="fix_nav">
      <b-container>
        <!-- 價格 -->
        <b-nav-item href="#price_part" :class="{ active: activeSection === 'price_part'}"
          v-if="tour.price_img.length>0||tour.available_date[0].dates[0]!==''">
          {{ $t('tourPrice') }}
        </b-nav-item>

        <!-- 出團狀況 -->
        <b-nav-item href="#departure_part" :class="{ active: activeSection === 'departure_part'}" v-if="registration.status">
          {{ $t('tourDeparture') }}
        </b-nav-item>

        <!-- 航班資訊-->
        <b-nav-item href="#flight" v-if="tour.flight&&tour.flight[0].airline">
          {{ $t('tourFlight') }}
        </b-nav-item>

        <!-- 行程 -->
        <b-nav-item href="#intro_part" :class="{ active: activeSection === 'intro_part'}">
          {{ $t('tourDescription') }}
        </b-nav-item>

        <!-- 注意事項 -->
        <!-- v-if="tour.noticeSelect[0]!==''" -->
        <b-nav-item href="#notice1" v-if="tour.noticeSelect[0] || tour.noticeInput[0].length>0">
          {{ $t('notice1') }}
        </b-nav-item>
        <b-nav-item href="#notice2" v-if="tour.language!=='en'&& (tour.noticeSelect[1] || tour.noticeInput[1].length>0)">
          {{ $t('notice2') }}
        </b-nav-item>
        <b-nav-item href="#notice3" v-if="tour.language!=='en'&& (tour.noticeSelect[2] || tour.noticeInput[2].length>0)">
          {{ $t('notice3') }}
        </b-nav-item>
        <b-nav-item href="#notice4" v-if="tour.language!=='en'&& (tour.noticeSelect[3] || tour.noticeInput[3].length>0)">
          {{ $t('notice4') }}
        </b-nav-item>
      </b-container>
    </b-navbar>
  </div>
</template>

<script>
export default {
  props: {
    tour: {
      type: Object,
      required: true
    },
    // 出團
    registration: {
    }
  },
  data () {
    return {
      activeSection: ''
    }
  },
  methodes: {
    // // 偵測 卷軸進度 nav
    // handleIntersection (entries) {
    //   entries.forEach((entry, index) => {
    //     // console.log(entry)
    //     if (entry.isIntersecting) {
    //       // console.log(entry.target.id)
    //       // 更新activeSection
    //       this.activeSection = entry.target.id
    //       // console.log(document.querySelector('[href="#' + entry.target.id + '"]'))
    //     }
    //   })
    // }
  },
  mounted () {
    // // 创建IntersectionObserver实例
    // const options = {
    //   root: null,
    //   rootMargin: '-40% 0px -55%',
    //   threshold: 0
    // }

    // // 定義要偵測的區塊(.href有id)
    // const sections = document.querySelectorAll('.section[id]')
    // console.log(sections)
    // // 針對三個區塊建立IntersectionObserver
    // const observer = new IntersectionObserver(this.handleIntersection, options)
    // sections.forEach(current => {
    //   // console.log(current)
    //   observer.observe(current)
    // })
  },
  beforeDestroy () {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
</script>
<style lang="scss">
#nav_fixed{
  // border-top: 1px solid rgb(218, 218, 218);
  // border-bottom: 1px solid rgb(218, 218, 218);
  background-color: #fff;
  border-bottom: 2px solid var(--myblue2);
  border-top: 2px solid var(--myblue2);
  position: sticky;
  top: -1px;
  z-index: 2;
  .fix_nav {
    // margin: 2rem 0;
    // border-top: 1px solid #eee;
    // border-bottom: 1px solid #eee;
    // background-color: #eee;
  }
  a {
    color: var(--myblue);
    font-weight: bold;
    font-size: .7rem;
    // padding: .3 .5rem !important;
  }
  li {
    list-style: none;
  }
  .nav-bar,
  .container {
    justify-content: start;
  }
  .nav-link {
      padding: .2rem .5rem;
    }
  @media (min-width:440px) {
    a {
      font-size: 1rem;
    }
    .nav-link {
      padding: .3rem .8rem;
    }
  }
}
</style>
